import BaseValidator from 'ember-cp-validations/validators/base';
import UrlWithTemplateString from './url-with-template-string';
const PointerHasSelector = BaseValidator.extend({
  validate(_value, _options, model) {
    if (model.isPost) {
      return true;
    }
    return model.hasSelector || 'Pointer steps require a selector';
  }
});
UrlWithTemplateString.reopenClass({
  getDependentsFor() {
    return ['model.hasSelector', 'model.isPost'];
  }
});
export default PointerHasSelector;